import { render, staticRenderFns } from "./NeiBuGongShi2.vue?vue&type=template&id=1ba6626b&scoped=true&"
import script from "./NeiBuGongShi2.vue?vue&type=script&lang=js&"
export * from "./NeiBuGongShi2.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuGongShi2.vue?vue&type=style&index=0&id=1ba6626b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6626b",
  null
  
)

export default component.exports